module.exports = __webpack_public_path__ + "assets/img/needTraining.ea5f9de3.png";